import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { IMLocationLookupLayout } from '../../../../../common/lookups/Layouts/ImLayouts';
import {  HandlingLayout} from '../Layout';
import { WM } from "../../../../../const/constants";
import { LocationTypes } from "../../../../../enum/Enum";
function HandlingTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [locationLayout, setLocationLayout] = useState(() =>
        IMLocationLookupLayout({ RWarehouse: props.formFields?.R_WAREHOUSE || '',moduleType:WM ,locationType :LocationTypes.StorageLocation})
    );
    const [formKey, setFormKey] = useState(0);
    const finalLayout = useMemo(() => {
        return HandlingLayout(locationLayout);
    }, [locationLayout]);
    const handleHandlingFormLoad = useCallback(() => {
        props.handlingFormLookupsLoad();
    }, []);
    useEffect(() => {
        // console.log("formFields", JSON.stringify(props.formFields, null, 2));
        // const newLayout = IMLocationLookupLayout({ RWarehouse: '5ADFA7EE-2759-4CC3-A5BE-8D09DDFFED03' });
        // setLocationLayout(newLayout);
    }, []);
    const handleSelectionChange = useCallback((name, value,e) => {
        if (name === "R_WAREHOUSE" && value) {
            const newLayout = IMLocationLookupLayout({ RWarehouse: value,moduleType:WM ,locationType :LocationTypes.StorageLocation});
            setLocationLayout(newLayout);
        }
        props.handleHandlingFieldChange(name, value);
    }, []);
    useEffect(() => {
        setFormKey(prev => prev + 1);
    }, [locationLayout]);
    return (
        <div>
            <FormField
                key={formKey}
                currrentUser={currentUser}
                layoutId='EE75A080-9641-4E9A-A3D5-A0E1314247E6'
                layoutName='WMItemDataEntryStatusForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleHandlingFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HandlingTab);
